"use strict";
var m = require('./mathTimo');

function max(a, b) {
    if (a > b) return a;
    return b;
}
function min(a, b) {
    if (a < b) return a;
    return b;
}
function between(a, b, c) {
    if (b < a) b = a;
    if (b > c) b = c;
    return b;
}
function createMask(page, width, limit) {
    var h = page.length / width
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            if (page[x + y * width] < limit) page[x + y * width] = 0;
            else page[x + y * width] = 2
        }
    }
}
function addLeadingZeros(n, nn) {
    var string = '';
    if (nn > 0) { if (n < 10) string += '0'; }
    if (nn > 1) { if (n < 100) string += '0'; }
    if (nn > 2) { if (n < 1000) string += '0'; }
    if (nn > 3) { if (n < 10000) string += '0'; }

    return string + n
}
function addLeadingSpaces(text, nn) {
    nn = nn - text.length;
    for (; nn >= 0; nn--)text = ' ' + text
    return text;
}
function scalePage(anyPage) {
    var min = m.min(anyPage);
    var max = m.max(anyPage);
    var l = anyPage.length;
    if (min == max) {
        debug('page min = max');
        return anyPage;
    }
    for (var i = 0; i < l; i++) anyPage[i] = Math.round(99 * ((anyPage[i] - min) / (max - min)));
    return anyPage;
}
function verticalBalancing(anyPage, width, maxim) {
    var l = anyPage.length
    var h = l / width
    for (var y = 0; y < h; y++) {
        var localMax = -100
        for (var x = 0; x < width; x++) {
            if (anyPage[x + y * width] > localMax) localMax = anyPage[x + y * width]
        }
    }
}
function cleanHorisontalLines(page, width) {
    var l = page.length;
    var h = l / width
    for (var y = 1; y < h - 1; y++) {
        for (var x = 0; x < width - 1; x++) {
            var i = x + y * width
            if (page[i] != 0 && page[i - width] == 0 && page[i + width] == 0) {
                page[i] = 0
            }
        }
    }
    for(var x=0;x<width-1;x++){
        if(page[x+width]==0 && page[x+width+1]==0)page[x]=0
        if(page[x+(h-2)*width]==0 && page[x+(h-2)*width+1]==0)page[x+(h-1)*width]=0
    }
}
function cleanVerticalLines(page, width) {
    var l = page.length;
    var h = l / width
    for (var x = 1; x < width - 1; x++) {
        for (var y = 0; y < h - 1; y++) {
            var i = x + y * width
            if (page[i] != 0 && page[i - 1] == 0 && page[i + 1] == 0) {
                page[i] = 0
            }
        }
    }
    for(var y=0;y<h-1;y++){
        if(page[y*width+1]==0 && page[(y+1)*width+1]==0)page[y*width]=0
        if(page[y*width+width-2]==0 && page[(y+1)*width+width-2]==0)page[y*width+width-1]=0
    }
}
function addMissingLines(page,width){
    var l=page.length;
    var h=l/width
    for (var y = 1; y < h - 1; y++) {
        for (var x = 0; x < width - 1; x++) {
            var i = x + y * width
            if (page[i - width] != 0 && page[i + width] != 0) {
                page[i] = 2
            }
        }
    }
    for (var x = 1; x < width - 1; x++) {
        for (var y = 0; y < h - 1; y++) {
            var i = x + y * width
            if (page[i - 1] != 0 && page[i + 1] != 0) {
                page[i] = 2
            }
        }
    }
}
function cleanUpPageEdges(page,width){
    var l = page.length;
    var h = l / width
    for(var x=0;x<width-1;x++){
        if(page[x+width]==0 && page[x+width+1]==0)page[x]=0
        if(page[x+(h-2)*width]==0 && page[x+(h-2)*width+1]==0)page[x+(h-1)*width]=0
    }
    for(var y=0;y<h-1;y++){
        if(page[y*width+1]==0 && page[(y+1)*width+1]==0)page[y*width]=0
        if(page[y*width+width-2]==0 && page[(y+1)*width+width-2]==0)page[y*width+width-1]=0
    }
}
function horisontalChanges(anyPage, width, numberColor) {
    var step = 0
    var l = anyPage.length
    var h = l / width
    var numberCode = 2
    if (numberColor != 'black') numberCode = 0;
    var aver = m.average(anyPage)
    var lowAve = 0
    var highAve = 0
    var lowCount = 0
    for (var i = 0; i < l; i++) {
        if (anyPage[i] > aver) highAve += anyPage[i];
        else {
            lowCount++
            lowAve += anyPage[i]
        }
    }
    if (lowCount == l || lowCount == 0) return anyPage
    lowAve = lowAve / lowCount
    highAve = highAve / (l - lowCount)
    step = 0.5 * (highAve - lowAve)
    var reference = anyPage[0]
    var white = true
    if (reference < aver) white = false
    var y = 0
    var x = 0
    var newPage = []
    // leftRight
    for (y = 0; y < h; y++) {
        for (x = 0; x < width; x++) {
            if (white) {
                if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] < reference - step) {
                    reference = anyPage[x + y * width]
                    white = false
                }
            } else {
                if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] > reference + step) {
                    reference = anyPage[x + y * width]
                    white = true
                }
            }
            if (white) newPage[x + y * width] = 1
            else newPage[x + y * width] = 0
        }
        if (y < h - 1) {
            y++
            for (x = width - 1; x >= 0; x--) {
                if (white) {
                    if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] < reference - step) {
                        reference = anyPage[x + y * width]
                        white = false
                    }
                } else {
                    if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] > reference + step) {
                        reference = anyPage[x + y * width]
                        white = true
                    }
                }
                if (white) newPage[x + y * width] = 1
                else newPage[x + y * width] = 0
            }
        }
    }
    var reference = anyPage[width - 1]
    var white = true
    if (reference < aver) white = false
    //rightLeft
    for (y = 0; y < h; y++) {
        for (x = width - 1; x >= 0; x--) {
            if (white) {
                if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] < reference - step) {
                    reference = anyPage[x + y * width]
                    white = false
                }
            } else {
                if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] > reference + step) {
                    reference = anyPage[x + y * width]
                    white = true
                }
            }
            if (white) newPage[x + y * width]++
        }
        if (y < h - 1) {
            y++
            for (var x = 0; x < width; x++) {
                if (white) {
                    if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] < reference - step) {
                        reference = anyPage[x + y * width]
                        white = false
                    }
                } else {
                    if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] > reference + step) {
                        reference = anyPage[x + y * width]
                        white = true
                    }
                }
                if (white) newPage[x + y * width]++
            }
        }
    }
    var reference = anyPage[0]
    var white = true
    if (reference < aver) white = false
    //topBottom
    for (x = 0; x < width; x++) {
        for (y = 0; y < h; y++) {
            if (white) {
                if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] < reference - step) {
                    reference = anyPage[x + y * width]
                    white = false
                }
            } else {
                if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] > reference + step) {
                    reference = anyPage[x + y * width]
                    white = true
                }
            }
            if (white) newPage[x + y * width]++
        }
        if (x < width - 1) {
            x++
            for (y = width - 1; y >= 0; y--) {
                if (white) {
                    if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] < reference - step) {
                        reference = anyPage[x + y * width]
                        white = false
                    }
                } else {
                    if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] > reference + step) {
                        reference = anyPage[x + y * width]
                        white = true
                    }
                }
                if (white) newPage[x + y * width]++
            }
        }
    }
    var reference = anyPage[width * (h - 1)]
    var white = true
    if (reference < aver) white = false
    //BottomTop
    for (x = 0; x < width; x++) {
        for (y = h - 1; y >= 0; y--) {
            if (white) {
                if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] < reference - step) {
                    reference = anyPage[x + y * width]
                    white = false
                }
            } else {
                if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                if (anyPage[x + y * width] > reference + step) {
                    reference = anyPage[x + y * width]
                    white = true
                }
            }
            if (white) newPage[x + y * width]++
        }
        if (x < width - 1) {
            x++
            for (y = 0; y < h; y++) {
                if (white) {
                    if (anyPage[x + y * width] > reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] < reference - step) {
                        reference = anyPage[x + y * width]
                        white = false
                    }
                } else {
                    if (anyPage[x + y * width] < reference) reference = anyPage[x + y * width];
                    if (anyPage[x + y * width] > reference + step) {
                        reference = anyPage[x + y * width]
                        white = true
                    }
                }
                if (white) newPage[x + y * width]++
            }
        }
    }
    for (var i = 0; i < l; i++) {
        if (newPage[i] < 2) newPage[i] = numberCode
        else newPage[i] = 2 - numberCode
    }
    cleanVerticalLines(newPage, width)
    cleanHorisontalLines(newPage, width)
    var numberi = extractLargestJoinedArea(newPage, width)
    addMissingLines(numberi,width)
    for (var i = 0; i < l; i++) {
        if (numberi[i] != 0) numberi[i] = 2
    }
    return numberi;
}

function cleanUpMask(m, width) {
    cleanUpPageEdges(m,width)
    var l = m.length;
    var h = l / width;
    var w = width;
    var newM = [];
    for (var i = 0; i < l; i++) {
        if (m[i] != 0) m[i] = 2;
        else m[i] = 0;
    }
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
            var x1 = max(0, x - 1);
            var x2 = x;
            var x3 = min(w - 1, x + 1);
            var y1 = max(0, y - 1);
            var y2 = y;
            var y3 = min(h - 1, y + 1);
            var environment = (m[y1 * w + x1] + m[y2 * w + x1] + m[y3 * w + x1] +
                m[y1 * w + x2] + m[y2 * w + x2] + m[y3 * w + x2] +
                m[y1 * w + x3] + m[y2 * w + x3] + m[y3 * w + x3]);

            newM[y * w + x] = m[y * w + x];
            if (m[y * w + x] == 0) {
                if (environment > 9) newM[y * w + x] = 2;
            } else {
                if (environment < 5) newM[y * w + x] = 0;
            }
        }
    }
    return newM;
}
function integrate3(p, width) {
    var h = p.length / width;
    var w = width;
    var newPage = [];
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
            var x1 = max(0, x - 1);
            var x2 = x;
            var x3 = min(w - 1, x + 1);
            var y1 = max(0, y - 1);
            var y2 = y;
            var y3 = min(h - 1, y + 1);
            newPage[y * w + x] = (p[y1 * w + x1] + p[y2 * w + x1] + p[y3 * w + x1] + p[y1 * w + x2] + p[y2 * w + x2] + p[y3 * w + x2] + p[y1 * w + x3] + p[y2 * w + x3] + p[y3 * w + x3]);
        }
    }
    return scalePage(newPage);
}
function joinPages(page1, page2) {
    var newPage = [];
    var i = 0
    for (i = 0; i < page1.length; i++)newPage.push(page1[i]);
    for (i = 0; i < page2.length; i++)newPage.push(page2[i]);
    return newPage;
}
function copyPage(page1, page2) {
    page2 = [];
    for (var i = 0; i < page1.length; i++)page2.push(page1[i]);
    return page2;
}
function changeArea(areas, oldArea, newArea) {
    var l = areas.length;
    for (var i = 0; i < l; i++) {
        if (areas[i] == oldArea) areas[i] = newArea;
    }
    return areas;
}
function changeAllAreas(areas, newArea) {
    var l = areas.length;
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) areas[i] = newArea;
    }
    return areas;
}
function areaData(a, number, width) {
    var h = a.length / width;
    var minx = width;
    var maxx = 0;
    var miny = h;
    var maxy = 0;
    var s = 0;
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            if (a[x + y * width] == number) {
                s++;
                //                minx = min(x, minx);
                if (x < minx) minx = x;
                //                miny = min(y, miny);
                if (y < miny) miny = y
                //                maxx = max(x, maxx);
                if (x > maxx) maxx = x
                //                maxy = max(y, maxy);
                if (y > maxy) maxy = y
            }
        }
    }
    return { 'x': minx, 'y': miny, 'height': (1 + maxy - miny), 'width': (1 + maxx - minx), 'size': s };

}
function numberArea(a, width) {
    var areas = findJoinedAreas(a, width)
    var largestArea = largestAreaNumber(areas);
    return areaData(areas, largestArea, width)
}
function numberSeparatorHeight(a, width) {
    var h = a.length / width
    var areas = findJoinedAreas(a, width)
    var largestArea = largestAreaNumber(areas)
    var nD = areaData(areas, largestArea, width)
    if (nD.width < 4) return 0;
    var topGap = 0;
    var rowSum = 0;
    var y = max(nD.y - 1, 0)
    while (y >= 0 && rowSum == 0) {
        rowSum = 0;
        for (var x = nD.x + 2; x < nD.x + nD.width - 2; x++) rowSum += a[x + y * width]
        if (rowSum == 0) topGap++;
        y--
    }
    var bottomGap = 0
    rowSum = 0
    var y = nD.y + nD.height
    while (y < h && rowSum == 0) {
        var rowSum = 0;
        for (var x = nD.x + 2; x < nD.x + nD.width - 2; x++)  rowSum += a[x + y * width]
        if (rowSum == 0) bottomGap++;
        y++
    }
    return min(((nD.height / 4) | 0), max(topGap, bottomGap));
}

function sputterAreas(area, width) {
    var h = area.length / width;
    for (var y = 0; y < h; y++) {
        var x = 0;
        while (area[x + y * width] == 0 && x < (width - 1)) x++;
        if (x < width - 1) area[x + 1 + y * width] = area[x + y * width];
        //        if (x < width - 2) area[x + 2 + y * width] = area[x + y * width]

        while (area[x + y * width] != 0 && x < (width - 1)) x++;
        while (area[x + y * width] == 0 && x < (width - 1)) x++;
        if (x < width - 1) area[x + 1 + y * width] = area[x + y * width]
        //        if (x < width - 2) area[x + 2 + y * width] = area[x + y * width]

        x = width - 1;
        while (area[x + y * width] == 0 && x > 0) x--;
        if (x > 0) area[x - 1 + y * width] = area[x + y * width]
        //        if (x > 1) area[x - 2 + y * width] = area[x + y * width]

        while (area[x + y * width] != 0 && x > 0) x--;
        while (area[x + y * width] == 0 && x > 0) x--;
        if (x > 0) area[x - 1 + y * width] = area[x + y * width]
        //        if (x > 1) area[x - 2 + y * width] = area[x + y * width]
    }
    for (var x = 0; x < width; x++) {
        var y = 0;
        while (area[x + y * width] == 0 && y < (h - 2)) y++;
        if (y < h - 1) area[x + (y + 1) * width] = area[x + y * width]
        //        if (y < width - 2) area[x + (y + 2) * width] = area[x + y * width]

        while (area[x + y * width] != 0 && y < (h - 1)) y++;
        while (area[x + y * width] == 0 && y < (h - 1)) y++;
        if (y < h - 1) area[x + (y + 1) * width] = area[x + y * width]
        //        if (y < width - 2) area[x + (y + 2) * width] = area[x + y * width]

        while (area[x + y * width] == 0 && y > 0) y--;
        if (y > 0) area[x + (y - 1) * width] = area[x + y * width]
        //        if (y > 1) area[x + (y - 2) * width] = area[x + y * width]

        while (area[x + y * width] != 0 && y > 0) y--;
        while (area[x + y * width] == 0 && y > 0) y--;
        if (y > 0) area[x + (y - 1) * width] = area[x + y * width]
        //        if (y > 1) area[x + (y - 2) * width] = area[x + y * width]
    }
    return area
}
function findAreaSize(a, number) {
    var l = a.length
    var count = 0
    for (var i = 0; i < l; i++) {
        if (a[i] == number) count++
    }
    return count;
}
function largestAreaNumber(a) {
    var maxAreaNumber = m.max(a);
    var l = a.length;
    if (maxAreaNumber == 0) return 0;
    var counts = [];
    for (var i = 0; i <= maxAreaNumber; i++)counts.push(0)
    for (var i = 0; i < l; i++)counts[a[i]]++;
    var largestAreaSize = 0;
    var largestAreaNumber = 0;
    for (var i = 1; i <= maxAreaNumber; i++) {
        if (counts[i] > largestAreaSize) {
            largestAreaSize = counts[i]
            largestAreaNumber = i
        }
    }
    if (largestAreaSize == 0) return 0;
    return largestAreaNumber;
}
function findJoinedAreas(m, width) {
    var currentArea = 10;
    var areas = [];
    var l = m.length;
    var starts = []
    for (var i = 0; i <= currentArea; i++)starts[i] = l - 1
    var h = l / width;
    for (var i = 0; i < l; i++)areas.push(0);
    var areaUsed = 0;
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            var index = x + y * width
            if (m[index] != 0) {
                areaUsed = 1;
                if (starts[currentArea] > index) starts[currentArea] = index
                areas[index] = currentArea;
                var dx = 0;
                var dy = 0;
                var adxdy = 0
                for (dy = -1; dy < 1; dy++) {
                    for (dx = -1; dx < 2; dx++) {
                        var xxx = x + dx
                        if (xxx < 0) xxx = 0
                        if (xxx > width - 1) xxx = width - 1
                        var yyy = y + dy
                        if (yyy < 0) yyy = 0
                        if (yyy > h - 1) yyy = h - 1
                        adxdy = areas[xxx + yyy * width];
                        if (adxdy != 0) {
                            if (areas[index] != adxdy) {
                                var newArea = areas[index]
                                if (starts[newArea] < starts[adxdy]) starts[adxdy] = starts[newArea]
                                if (starts[adxdy] < starts[newArea]) starts[newArea] = starts[adxdy]
                                for (var j = starts[newArea]; j <= index; j++) { if (areas[j] == newArea) areas[j] = adxdy }
                                areaUsed = 0
                            }
                            areas[index] = adxdy;
                        }
                    }
                }
            } else {
                if (areaUsed != 0) {
                    areaUsed = 0;
                    currentArea++
                    starts[currentArea] = l - 1
                } else starts[currentArea] = l - 1

            }
        }
        if (y < h - 1) {
            for (var x = width - 1; x >= 0; x--) {
                var index = x + (y + 1) * width
                if (m[index] != 0) {
                    areaUsed = 1;
                    if (starts[currentArea] > index) starts[currentArea] = index
                    areas[index] = currentArea;
                    var dx = 0;
                    var dy = 0;
                    var adxdy = 0
                    for (dy = -1; dy < 1; dy++) {
                        for (dx = -1; dx < 2; dx++) {
                            var xxx = x + dx
                            if (xxx < 0) xxx = 0
                            if (xxx > width - 1) xxx = width - 1
                            yyy = (y + 1) + dy
                            if (yyy < 0) yyy = 0
                            if (yyy > h - 1) yyy = h - 1
                            adxdy = areas[xxx + yyy * width];
                            if (adxdy != 0) {
                                if (areas[index] != adxdy) {
                                    var limit = (y + 2) * width
                                    var newArea = areas[index]
                                    if (starts[newArea] < starts[adxdy]) starts[adxdy] = starts[newArea]
                                    if (starts[adxdy] < starts[newArea]) starts[newArea] = starts[adxdy]
                                    for (var j = starts[newArea]; j < limit; j++) { if (areas[j] == newArea) areas[j] = adxdy }
                                    areaUsed = 0
                                }
                                areas[index] = adxdy;
                            }
                        }
                    }
                } else {
                    if (areaUsed != 0) {
                        areaUsed = 0;
                        currentArea++
                        starts[currentArea] = l - 1
                    } else starts[currentArea] = l - 1

                }
            }
            y++
        }
    }
    return areas;
}

function cleanupArray(array) {
    if (array.length == 0) return array;
    array = array.sort();
    var l = array.length;
    var result = [];
    var max = m.max(array);
    for (var i = 0; i < l; i++) {
        var found = 0;
        for (var n = 0; n <= max; n++) {
            if (n == array[i]) found = n;
        }
        if (found != 0) result.push(found);
    }
    return result;
}
function findEdgeAreas(areas, width) {
    var edgeAreas = [];
    var l = areas.length;
    var h = l / width
    for (var x = 0; x < width; x++) { if (areas[x] != 0) edgeAreas.push(areas[x]); }
    for (var x = 0; x < width; x++) { if (areas[x + (h - 1) * width] != 0) edgeAreas.push(areas[x + (h - 1) * width]); }
    for (var y = 0; y < h; y++) { if (areas[y * width] != 0) edgeAreas.push(areas[y * width]); }
    for (var y = 0; y < h; y++) { if (areas[y * width + width - 1] != 0) edgeAreas.push(areas[y * width + width - 1]); }
    return cleanupArray(edgeAreas);
}
function extractLargestJoinedArea(areas, width) {
    areas = findJoinedAreas(areas, width)
    var largestArea = largestAreaNumber(areas)
    return extractArea(areas, largestArea)

}
function extractArea(areas, areaNumber) {
    var l = areas.length;
    for (var i = 0; i < l; i++) {
        if (areas[i] != areaNumber) areas[i] = 0;
    }
    return areas
}
function removeEdgeAreas(areas, width) {
    var edges = findEdgeAreas(areas, width)
    var newArea = copyPage(areas, newArea)
    for (var j = 0; j < edges.length; j++)changeArea(newArea, edges[j], 0);
    return newArea;
}
function findHoles(areas, width) {
    var holeAreas = copyPage(areas, holeAreas)
    var largestArea = largestAreaNumber(holeAreas)
    holeAreas = extractArea(holeAreas, largestArea);
    holeAreas = invertArea(holeAreas)
    holeAreas = findJoinedAreas(holeAreas, width);
    return removeEdgeAreas(holeAreas, width)
}
function holes(areas, width) {
    var holeAreas = findHoles(areas, width)
    var holeData = [];
    var largestHole = largestAreaNumber(holeAreas)
    for (var n = 0; n < 3 && largestHole != 0; n++) {
        var hole = areaData(holeAreas, largestHole, width)
        var cOg = centerOfGravity(holeAreas, largestHole, width)
        hole.xG = cOg.xG
        hole.yG = cOg.yG
        hole.roundness = cOg.roundness
        hole.ovality = cOg.ovality
        holeData.push(hole);
        holeAreas = changeArea(holeAreas, largestHole, 0)
        largestHole = largestAreaNumber(holeAreas)
    }
    return holeData
}
function fillAllButLargestHole(areas, width) {
    var number = largestAreaNumber(areas, width)
    var h = areas.length / width
    var holeAreas = findHoles(areas, width)
    var largestHole = largestAreaNumber(holeAreas)
    holeAreas = changeArea(holeAreas, largestHole, 0)
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            if (holeAreas[x + y * width] != 0) areas[x + y * width] = number
        }
    }
    return areas;
}
function cleanSmallAreas(a, width) {
    var maxi = m.max(a)
    for (var i = 1; i <= maxi; i++) {
        var size = findAreaSize(a, i)
        if (size < 10) changeArea(a, i, 0)
    }
    return a
}
function cropPage(page, width, aD) {
    var h = page.length / width
    var c = []
    if (aD.height == 0 || aD.width == 0) return { 'page': page, 'width': aD.width, 'height': aD.height }
    for (var y = aD.y; y < aD.y + aD.height; y++) {
        for (var x = aD.x; x < aD.x + aD.width; x++) {
            c.push(page[x + y * width])
        }
    }
    return { 'page': c, 'width': aD.width, 'height': aD.height }
}
/*
function features(a, width) {
    var allFeaturesArea = copyPage(a, allFeaturesArea)
    allFeaturesArea = findJoinedAreas(allFeaturesArea, width)
    allFeaturesArea = cleanSmallAreas(allFeaturesArea, width)
    var features = [];
    var feature = {}
    var hole = {}
    var cOg = {}
    var areas = copyPage(allFeaturesArea, areas)
    var cropped = []
    areas = copyPage(allFeaturesArea, areas)
    var largestFeature = largestAreaNumber(areas)
    for (var n = 0; n < 10 && largestFeature != 0; n++) {
        areas = extractArea(areas, largestFeature)
        feature = areaData(areas, largestFeature, width)
        cropped = cropPage(areas, width, feature)
        console.log('looking for feature ' + n)
        var holeAreas = findHoles(cropped.page, cropped.width)
        var largestHole = largestAreaNumber(holeAreas)
        hole = {}
        if (largestHole != 0) {
            holeAreas = extractArea(holeAreas, largestHole)
            hole = areaData(holeAreas, largestHole, cropped.width)
            hole.x += feature.x
            hole.y += feature.y
            cOg = centerOfGravity(holeAreas, largestHole, cropped.width)
            hole.xG = cOg.xG + feature.x
            hole.yG = cOg.yG + feature.y
            hole.roundness = cOg.roundness
            hole.ovality = cOg.ovality
        } else {
            cOg = centerOfGravity(areas, largestFeature, width)
            feature.xG = cOg.xG
            feature.yG = cOg.yG
            feature.roundness = cOg.roundness
            feature.ovality = cOg.ovality
        }
        features.push({ 'feature': feature, 'hole': hole });
        allFeaturesArea = changeArea(allFeaturesArea, largestFeature, 0)
        areas = copyPage(allFeaturesArea, areas)
        largestFeature = largestAreaNumber(areas)
    }
    return features
}
*/
var longRayWidthRatioLimit = 0.75
var longRayHeightRatioLimit = 0.7
function roofRadar(a, width, n) {
    var h = a.length / width
    var rays = []
    for (var x = 0; x < width; x++) {
        rays[x] = 0
        var y = 0
        while (y < h && a[x + y * width] == 0) y++
        while (y < h && a[x + y * width] != 0) {
            rays[x]++
            y++
        }
    }
    var result = {}
    result.rightSideRay=rays[width-1]
    result.leftSideRay=rays[0]
    result.min = m.min(rays)
    result.max = m.max(rays)
    result.average = Math.round(m.average(rays))
    result.median = Math.round(m.median(rays))
    result.leftIndex = -1;
    result.rightIndex = -1;
    result.size = 0
    result.count = 0
    for (var i = 0; i < rays.length; i++) {
        if (rays[i] > n.number.height * longRayHeightRatioLimit) {
            if (result.leftIndex < 0) result.leftIndex = i
            result.rightIndex = i
            result.size += rays[i]
            result.count++
        }
    }
    return result
}
function floorRadar(a, width, n) {
    var h = a.length / width
    var rays = []
    for (var x = 0; x < width; x++) {
        rays[x] = 0
        var y = h - 1
        while (y >= 0 && a[x + y * width] == 0) y--
        while (y >= 0 && a[x + y * width] != 0) {
            rays[x]++
            y--
        }
    }
    var result = {}
    result.min = m.min(rays)
    result.max = m.max(rays)
    result.average = Math.round(m.average(rays))
    result.median = Math.round(m.median(rays))
    result.leftIndex = -1;
    result.rightIndex = -1;
    result.size = 0
    result.count = 0
    for (var i = 0; i < rays.length; i++) {
        if (rays[i] > n.number.height * longRayHeightRatioLimit) {
            if (result.leftIndex < 0) result.leftIndex = i
            result.rightIndex = i
            result.size += rays[i]
            result.count++
        }
    }
    return result
}
function leftRadar(a, width, n) {
    var h = a.length / width
    var rays = []
    for (var y = 0; y < h; y++) {
        rays[y] = 0
        var x = 0
        while (x < width && a[x + y * width] == 0) x++
        while (x < width && a[x + y * width] != 0) {
            rays[y]++
            x++
        }
    }
    var result = {}
    result.min = m.min(rays)
    result.max = m.max(rays)
    result.average = Math.round(m.average(rays))
    result.median = Math.round(m.median(rays))
    result.topIndex = -1;
    result.bottomIndex = -1;
    result.size = 0
    result.count = 0
    for (var i = 0; i < rays.length; i++) {
        if (rays[i] > n.number.width * longRayWidthRatioLimit) {
            if (result.topIndex < 0) result.topIndex = i
            result.bottomIndex = i
            result.size += rays[i]
            result.count++
        }
    }
    return result
}


function holeDips(areas, width, n) {
    var result = { 'size': 0 }
    if (n.holes.length != 1) return result;
    var holeAreas = findHoles(areas, width)
    var lTE = leftTopEdge(holeAreas, width)
    var lBE = leftBottomEdge(holeAreas, width)
    var rTE = rightTopEdge(holeAreas, width)
    var rBE = rightBottomEdge(holeAreas, width)
    var xMin = max(lTE.x, lBE.x)
    var xMax = min(rTE.x, rBE.x)
    var leftCount = 0
    var y = lTE.y;
    while (y < lBE.y) {
        var x = xMin
        while (x < xMax && holeAreas[x + y * width] == 0) {
            leftCount++
            x++
        }
        y++
    }
    var rightCount = 0
    var y = rTE.y;
    while (y < rBE.y) {
        var x = xMax
        while (x > xMin && holeAreas[x + y * width] == 0) {
            rightCount++
            x--
        }
        y++
    }
    return { 'leftSize': leftCount, 'rightSize': rightCount };
}
function cleanTopCorners(areas, width) {
    var h = areas.length / width
    var y = 0;
    var found = 0
    var x = 0
    while (y < h / 2 && found == 0) {
        for (x = ((width / 3) | 0); x < width; x++) {
            if (areas[x + y * width] != 0) found = 1;
        }
        if (found == 0) {
            for (x = 0; x < width; x++)areas[x + y * width] = 0
        }
        y++;
    }
    return areas
}

function rightTopEdge(areas, width) {
    var edge = [];
    var y = 0;
    var h = areas.length / width
    for (y = 0; y < h; y++) {
        edge[y] = -1
        for (var x = 0; x < width; x++) {
            if (areas[x + y * width] != 0) edge[y] = x;
        }
    }
    var max = -1
    var y1 = 0
    y = 0;
    while (y < h && edge[y] >= (max - 1)) {
        if (edge[y] > max) {
            y1 = y;
            max = edge[y]
        }
        y++
    }
    return { 'x': max, 'y': y1 }
}
function leftTopEdge(areas, width) {
    var edge = [];
    var y = 0;
    var h = areas.length / width
    for (y = 0; y < h; y++) {
        edge[y] = width
        for (var x = width - 1; x >= 0; x--) {
            if (areas[x + y * width] != 0) edge[y] = x;
        }
    }
    var min = width
    var y1 = 0
    y = 0;
    while (y < h && edge[y] <= (min + 1)) {
        if (edge[y] < min) {
            y1 = y;
            min = edge[y]
        }
        y++
    }
    return { 'x': min, 'y': y1 }
}
function rightBottomEdge(areas, width) {
    var edge = [];
    var y = 0;
    var h = areas.length / width
    for (y = h - 1; y >= 0; y--) {
        edge[y] = -1
        for (var x = 0; x < width; x++) {
            if (areas[x + y * width] != 0) edge[y] = x;
        }
    }
    var max = -1
    var y1 = 0
    y = h - 1;
    while (y >= 0 && edge[y] >= (max - 1)) {
        if (edge[y] > max) {
            y1 = y;
            max = edge[y]
        }
        y--
    }
    return { 'x': max, 'y': y1 }
}
function leftBottomEdge(areas, width) {
    var edge = [];
    var y = 0;
    var h = areas.length / width
    for (y = h - 1; y >= 0; y--) {
        edge[y] = width
        for (var x = width - 1; x >= 0; x--) {
            if (areas[x + y * width] != 0) edge[y] = x;
        }
    }
    var min = width
    var y1 = 0
    y = h - 1;
    while (y >= 0 && edge[y] <= (min + 1)) {
        if (edge[y] < min) {
            y1 = y;
            min = edge[y]
        }
        y--
    }
    return { 'x': min, 'y': y1 }
}
function floorLeftEdge(areas, width) {
    var edge = [];
    var xx = 0;
    var h = areas.length / width
    for (xx = 0; xx < width; xx++) {
        edge[xx] = -1
        for (var yy = 0; yy < h; yy++) {
            if (areas[xx + yy * width] != 0) edge[xx] = yy;
        }
    }
    var max = -1
    var xx1 = 0
    xx = 0;
    while (xx < width && edge[xx] >= (max - 1)) {
        if (edge[xx] > max) {
            xx1 = xx;
            max = edge[xx]
        }
        xx++
    }
    return { 'x': xx1, 'y': max }
}
function roofLeftEdge(areas, width) {
    var edge = [];
    var xx = 0;
    var h = areas.length / width
    for (xx = 0; xx < width; xx++) {
        edge[xx] = h
        for (var yy = h - 1; yy >= 0; yy--) {
            if (areas[xx + yy * width] != 0) edge[xx] = yy;
        }
    }
    var min = h
    var xx1 = 0
    xx = 0;
    while (xx < width && edge[xx] <= (min + 1)) {
        if (edge[xx] < min) {
            xx1 = xx;
            min = edge[xx]
        }
        xx++
    }
    return { 'x': xx1, 'y': min }
}
function floorRightEdge(areas, width) {
    var edge = [];
    var xx = 0;
    var h = areas.length / width
    for (xx = width - 1; xx >= 0; xx--) {
        edge[xx] = -1
        for (var yy = 0; yy < h; yy++) {
            if (areas[xx + yy * width] != 0) edge[xx] = yy;
        }
    }
    var max = -1
    var xx1 = 0
    xx = width - 1;
    while (xx >= 0 && edge[xx] >= (max - 1)) {
        if (edge[xx] > max) {
            xx1 = xx;
            max = edge[xx]
        }
        xx--
    }
    return { 'x': xx1, 'y': max }
}
function roofRightEdge(areas, width) {
    var edge = [];
    var xx = 0;
    var h = areas.length / width
    for (xx = width - 1; xx >= 0; xx--) {
        edge[xx] = h
        for (var yy = h - 1; yy >= 0; yy--) {
            if (areas[xx + yy * width] != 0) edge[xx] = yy;
        }
    }
    var min = h
    var xx1 = 0
    xx = width - 1;
    while (xx >= 0 && edge[xx] <= (min + 1)) {
        if (edge[xx] < min) {
            xx1 = xx;
            min = edge[xx]
        }
        xx--
    }
    return { 'x': xx1, 'y': min }
}
function invertArea(area) {
    var l = area.length
    for (var i = 0; i < l; i++) {
        if (area[i] != 0) area[i] = 0
        else area[i] = 2
    }
    return area
}

var radarResolution = 15 * 3.141593 / 180
function radarEdges(areas, width) {
    var h = areas.length / width
    var areaNumber = largestAreaNumber(areas)
    var cOG = centerOfGravity(areas, areaNumber, width)
    var radar = []
    var scanCount = 2 * 3.141593 / radarResolution
    for (var i = 0; i < scanCount; i++) {
        var dx = Math.cos(3.141593 / 2 - radarResolution * i) * 0.25
        var dy = -Math.sin(3.141593 / 2 - radarResolution * i) * 0.25
        var maxDistance = 0
        var x = cOG.xG
        var y = cOG.yG
        for (var step = 0; (x >= 0 && y >= 0 && x < width && y < h); step++) {
            if (areas[Math.round(x) + Math.round(y) * width] != 0) maxDistance = step * 0.25
            x += dx
            y += dy
        }
        radar.push(maxDistance)
    }
    var maxx = m.max(radar)
    var minx = m.min(radar)
    var hysteresis = (maxx - minx) / 8
    for (var i = 0; i < scanCount; i++)radar.push(radar[i])
    var i = 0
    var value = 0
    while (i < scanCount && radar[i] < maxx) i++
    var lastIndex = i + scanCount
    while (i < lastIndex && radar[i] > maxx - hysteresis) i++;
    var topSize = 0
    var bottomSize = 0;
    var box = areas.length
    for (var i = 0; i < box; i++) {
        if (i < box * 0.5 && areas[i] != 0) topSize++
        if (i >= box * 0.5 && areas[i] != 0) bottomSize++
    }
    var ovality = 10000;
    if (minx != 0) ovality = Math.round(100 * maxx / minx)
    var topBottomRatio = 100
    if (bottomSize != 0) topBottomRatio = Math.round(100 * topSize / bottomSize) / 100
    return { 'topBottomRatio': topBottomRatio, 'ovality': ovality, 'xG': cOG.xG, 'yG': cOG.yG }
}


function centerOfGravity(area, number, width) {
    var circleArea = findAreaSize(area, number);
    var radiusSquared = circleArea / 3.1415
    var sumY = 0;
    var sumX = 0
    var count = 0;
    var h = area.length / width
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            if (area[x + y * width] == number) {
                count++;
                sumX += x;
                sumY += y
            }
        }
    }
    var xG = 0
    var yG = 0
    if (count > 0) {
        xG = ((sumX*10 / count)|0)/10
        yG = ((sumY*10 / count)|0)/10
    }
    var insideCircle = 0
    var maxDistance = 0
    var minDistance = 10000
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            var distance = ((x - xG) * (x - xG) + (y - yG) * (y - yG))
            if (area[x + y * width] == number) {
                if (distance < radiusSquared) insideCircle++;
                maxDistance = max(maxDistance, distance)
            } else {
                minDistance = min(minDistance, distance)
            }
        }
    }
    if (count > 0) {
        insideCircle = (100 * insideCircle / count) | 0
    }
    var ovality = 1
    if (minDistance > 0) ovality = (100 * Math.sqrt(maxDistance / minDistance)) | 0
    return { 'xG': xG, 'yG': yG, 'roundness': insideCircle, 'ovality': ovality }
}
function topBarBottomCurve(areas, width, n) {
    var result = { 'size': 0 }
    var a = copyPage(areas, a)
    var l = areas.length
    var h = l / width
    for (var i = 0; i < l; i++) { if (areas[i] != 0) a[i] = 1 }
    for (var y = n.leftTopEdge.y; areas[y * width + n.leftTopEdge.x] != 0 && y < h - 1; y++);
    for (var i = y * width; i < l; i++) a[i] = 1
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function diagonalBarCurve(areas, width, n) {
    var result = { 'size': 0 }
    var l = areas.length
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    var h = l / width
    if (n.holes.length > 1) return result
    if (n.rightTopEdge.y >= n.leftBottomEdge.y) return result;
    for (var y = n.rightTopEdge.y; y <= n.leftBottomEdge.y; y++) {
        var k = (n.leftBottomEdge.x - n.rightTopEdge.x) / (n.leftBottomEdge.y - n.rightTopEdge.y)
        var xMax = n.rightTopEdge.x + k * (y - n.rightTopEdge.y)
        for (var x = 0; x < xMax; x++)a[x + y * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function rightTopDipDiagonalCurve(areas, width, n) {
    var result = { 'size': 0 }
    var l = areas.length
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    var h = l / width
    if (n.rightTopDip.size == 0) return result
    if (n.holes.length != 0) return result
    if (n.roofRightEdge.y >= n.leftBottomEdge.y) return result;
    for (var y = n.roofRightEdge.y; y <= n.leftBottomEdge.y; y++) {
        var k = (n.leftBottomEdge.x - n.roofRightEdge.x) / (n.leftBottomEdge.y - n.roofRightEdge.y)
        var xMin = n.roofRightEdge.x + k * (y - n.roofRightEdge.y)
        for (var x = width - 1; x > xMin; x--)a[x + y * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function rightTopDipDiagonalCurveFor4(areas, width, n) {
    var result = { 'size': 0 }
    var l = areas.length
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    var h = l / width
    if (n.rightTopDip.size == 0) return result
    if (n.holes.length != 0) return result
    var rM = roofMax(a, width)
    if (rM.y >= n.leftBottomEdge.y) return result;
    for (var y = rM.y; y <= n.leftBottomEdge.y; y++) {
        var k = (n.leftBottomEdge.x - rM.x) / (n.leftBottomEdge.y - rM.y)
        var xMin = rM.x + k * (y - rM.y)
        for (var x = width - 1; x > xMin; x--)a[x + y * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}

function roofLeftConcave(areas, width, n) {
    var newArea = []
    var l = areas.length
    var result = { 'size': 0 }
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    var h = l / width
    if (n.roofDip.size != 0) return result
    if (n.holes.length != 0) {
        newArea = copyPage(a, newArea)
        newArea = invertArea(newArea);
        newArea = findJoinedAreas(newArea, width)
        newArea = removeEdgeAreas(newArea, width)
        for (var i = 0; i < l; i++) {
            if (newArea[i] != 0) a[i] = 1;
        }
    }
    if (n.roofRightEdge.x <= n.leftTopEdge.x) return result;
    for (var xx = n.leftTopEdge.x; xx <= n.roofRightEdge.x; xx++) {
        var k = (n.leftTopEdge.y - n.roofRightEdge.y) / (n.leftTopEdge.x - n.roofRightEdge.x)
        var yyMax = n.roofRightEdge.y + k * (xx - n.roofRightEdge.x)
        for (var yy = 0; yy < yyMax; yy++)a[xx + yy * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function roofLeftConvex(areas, width, n) {
    var newArea = []
    var l = areas.length
    var h = l / width
    var result = { 'size': 0 }
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    if (n.roofDip.size != 0) return result
    if (n.holes.length != 0) {
        newArea = copyPage(a, newArea)
        newArea = invertArea(newArea);
        newArea = findJoinedAreas(newArea, width)
        newArea = removeEdgeAreas(newArea, width)
        for (var i = 0; i < l; i++) {
            if (newArea[i] != 0) a[i] = 1;
        }
    }
    if (n.roofLeftEdge.x <= n.leftTopEdge.x) return result;
    for (var xx = 0; xx < width; xx++) {
        var k = (n.leftTopEdge.y - n.roofLeftEdge.y) / (n.leftTopEdge.x - n.roofLeftEdge.x)
        var yyMax = (n.roofLeftEdge.y + k * (xx - n.roofLeftEdge.x)) | 0
        for (var yy = min(h - 1, yyMax); yy < h; yy++)a[xx + yy * width] = 0
    }
    result.size = findAreaSize(a, 1)
    return result
}
function roofTopConvex(areas, width) {
    var newArea = []
    var l = areas.length
    var h = l / width
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    for (var y = min(leftTopEdge(areas, width).y, rightTopEdge(areas, width).y); y < h; y++) {
        for (var x = 0; x < width; x++)a[x + y * width] = 0
    }
    return findAreaSize(a, 1)
}

function floorMin(areas, width) {
    var h = areas.length / width
    for (var x = 0; x < width; x++) {
        for (var y = h - 1; y >= 0; y--) {
            if (areas[x + y * width] != 0) return { 'x': x, 'y': y }
        }
    }
    return { 'x': width - 1, 'y': 0 }
}
function roofMax(areas, width) {
    var h = areas.length / width
    for (var x = width - 1; x >= 0; x--) {
        for (var y = 0; y < h; y++) {
            if (areas[x + y * width] != 0) return { 'x': x, 'y': y }
        }
    }
    return { 'x': 0, 'y': h - 1 }
}
function floorLeftCurveFor4(areas, width, n) {
    var newArea = []
    var result = { 'size': 0 }
    var l = areas.length
    var h = l / width
    var a = copyPage(areas, a)
    for (var i = 0; i < l; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    if (n.floorDip.size != 0) return result
    if (n.holes.length != 0) {
        newArea = copyPage(a, newArea)
        newArea = invertArea(newArea);
        newArea = findJoinedAreas(newArea, width)
        newArea = removeEdgeAreas(newArea, width)
        for (var i = 0; i < l; i++) {
            if (newArea[i] != 0) a[i] = 1;
        }
    }
    var lBM = floorMin(areas, width)
    if (n.floorRightEdge.x <= lBM.x) return result;
    for (var xx = lBM.x; xx <= n.floorRightEdge.x; xx++) {
        var k = (lBM.y - n.floorRightEdge.y) / (lBM.x - n.floorRightEdge.x)
        var yyMin = n.floorRightEdge.y + k * (xx - n.floorRightEdge.x)
        for (var yy = h - 1; yy >= yyMin; yy--)a[xx + yy * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function floorLeftCurve(areas, width, n) {
    var newArea = []
    var result = { 'size': 0 }
    var l = areas.length
    var h = l / width
    var a = copyPage(areas, a)
    for (var i = 0; i < h; i++) {
        if (areas[i] != 0) a[i] = 1
    }
    if (n.floorDip.size != 0) return result
    if (n.holes.length != 0) {
        newArea = copyPage(a, newArea)
        newArea = invertArea(newArea);
        newArea = findJoinedAreas(newArea, width)
        newArea = removeEdgeAreas(newArea, width)
        for (var i = 0; i < areas.length; i++) {
            if (newArea[i] != 0) a[i] = 1;
        }
    }
    if (n.floorRightEdge.x <= n.leftBottomEdge.x) return result;
    for (var xx = n.leftBottomEdge.x; xx <= n.floorRightEdge.x; xx++) {
        var k = (n.leftBottomEdge.y - n.floorRightEdge.y) / (n.leftBottomEdge.x - n.floorRightEdge.x)
        var yyMin = n.floorRightEdge.y + k * (xx - n.floorRightEdge.x)
        for (var yy = h - 1; yy >= yyMin; yy--)a[xx + yy * width] = 1
    }
    var hD = holes(a, width)
    if (hD.length == 0) return result;
    result.size = hD[0].size
    return result
}
function roofAndFloorDip(areas, width) {
    var result = {};
    result.roofDip = { 'size': 0 }
    result.floorDip = { 'size': 0 }
    var l = areas.length
    var h = l / width
    var roofDipArea = copyPage(areas, roofDipArea);
    var holeAreas = findHoles(areas, width);
    for (var i = 0; i < l; i++)roofDipArea[i] += holeAreas[i]
    roofDipArea = invertArea(roofDipArea);
    var floorDipArea = copyPage(roofDipArea, floorDipArea)

    var roofMinimi = roofLeftEdge(areas, width)
    var roofMaximi = roofRightEdge(areas, width);
    if (roofMinimi.x + 1 < roofMaximi.x) {
        for (var x = 0; x < width; x++) {
            for (var y = max(0, min(roofMinimi.y, roofMaximi.y)); y < min(h, 1 + max(roofMinimi.y, roofMaximi.y)); y++) roofDipArea[x + y * width] = 0
        }
        roofDipArea = findJoinedAreas(roofDipArea, width)
        roofDipArea = removeEdgeAreas(roofDipArea, width)
        var dip = largestAreaNumber(roofDipArea)
        if (dip != 0) {
            result.roofDip = areaData(roofDipArea, dip, width)
            var centerOfGravityPoint = centerOfGravity(roofDipArea, dip, width)
            result.roofDip.xG = centerOfGravityPoint.xG
            result.roofDip.yG = centerOfGravityPoint.yG
        }
    }

    var floorMinimi = floorLeftEdge(areas, width)
    var floorMaximi = floorRightEdge(areas, width);
    if (floorMinimi.x + 1 < floorMaximi.x) {
        for (var x = 0; x < width; x++) {
            for (var y = max(0, min(floorMinimi.y, floorMaximi.y) - 1); y < min(h, max(floorMinimi.y, floorMaximi.y)); y++) floorDipArea[x + y * width] = 0
        }
        floorDipArea = findJoinedAreas(floorDipArea, width)
        floorDipArea = removeEdgeAreas(floorDipArea, width)
        var dip = largestAreaNumber(floorDipArea)
        if (dip != 0) {
            result.floorDip = areaData(floorDipArea, dip, width)
            var centerOfGravityPoint = centerOfGravity(floorDipArea, dip, width)
            result.floorDip.xG = centerOfGravityPoint.xG
            result.floorDip.yG = centerOfGravityPoint.yG
        }
    }
    return result
}
function leftDip(areas, width, n) {
    var resultAll = { 'size': 0 }
    var resultTop = { 'size': 0 }
    var resultBottom = { 'size': 0 }
    var result = { 'leftDip': { 'size': 0 }, 'leftTopDip': { 'size': 0 }, 'leftBottomDip': { 'size': 0 } }
    var l = areas.length
    var h = l / width
    var newArea = copyPage(areas, newArea);
    var minimi = leftTopEdge(areas, width)
    var maximi = leftBottomEdge(areas, width);
    if (minimi.y + 1 >= maximi.y) return result;
    var newArea2 = findHoles(areas, width);
    for (var i = 0; i < l; i++)newArea[i] += newArea2[i]
    var minX = min(minimi.x, maximi.x)
    var maxX = min(max(minimi.x, maximi.x) + 1, width)
    for (var y = max(0, minimi.y - 1); y < min(h - 1, maximi.y + 2); y++) {
        for (var x = minX; x < maxX; x++)newArea[x + y * width] = 2;
    }
    newArea = invertArea(newArea);
    newArea = findJoinedAreas(newArea, width)
    newArea = removeEdgeAreas(newArea, width)
    var dip = largestAreaNumber(newArea)
    var midPointY = (n.y + n.height * 0.5) | 0
    var midPoint = midPointY * width
    for (var i = 0; i < l; i++) { if (newArea[i] != 0) newArea[i] = dip }
    var topDipArea = []
    for (var i = 0; i < midPoint; i++)topDipArea.push(newArea[i])
    var bottomDipArea = []
    for (var i = midPoint; i < l; i++)bottomDipArea.push(newArea[i])

    var topRayDipPointY = 0
    var topRayDipPointYTop = 0
    var bottomRayDipPointY = -1
    var bottomRayDipPointYBottom = -1
    if (dip != 0) {
        resultTop = areaData(topDipArea, dip, width)
        if (resultTop.size != 0) {
            var centerOfGravityPoint = centerOfGravity(topDipArea, dip, width)
            resultTop.xG = centerOfGravityPoint.xG
            resultTop.yG = centerOfGravityPoint.yG
            for (var y = resultTop.y + resultTop.height - 1; y >= resultTop.y; y--) {
                var x = 0;
                var topRayDipPointDepth = 0
                while (x < width && areas[x + y * width] == 0) {
                    x++;
                    topRayDipPointDepth++
                    if (topRayDipPointDepth > 0.4 * width) {
                        topRayDipPointYTop = y
                        if (topRayDipPointY == 0) topRayDipPointY = y
                    }
                }
            }
            var rayToDipBottomDistance = 0
            var y = topRayDipPointY + 1
            var x = Math.round(width * 0.4)
            while (y < resultTop.y + resultTop.height && topDipArea[y * width + x]) {
                rayToDipBottomDistance++
                y++
            }
            resultTop.rayYTop = topRayDipPointYTop
            resultTop.rayY = topRayDipPointY
            resultTop.rayToDipBottom = rayToDipBottomDistance

        } else resultTop = { 'size': 0 };
        resultBottom = areaData(bottomDipArea, dip, width)
        if (resultBottom.size != 0) {
            var centerOfGravityPoint = centerOfGravity(bottomDipArea, dip, width)
            resultBottom.xG = centerOfGravityPoint.xG
            resultBottom.yG = centerOfGravityPoint.yG
            for (var y = resultBottom.y; y < resultBottom.y + resultBottom.height; y++) {
                var x = 0;
                var bottomRayDipPointDepth = 0
                while (x < width && areas[x + (y + midPointY) * width] == 0) {
                    x++;
                    bottomRayDipPointDepth++
                    if (bottomRayDipPointDepth > 0.4 * width) {
                        if (bottomRayDipPointY == -1) bottomRayDipPointY = y
                        bottomRayDipPointYBottom = y
                    }
                }
            }
            var rayToDipTopDistance = 0
            var y = bottomRayDipPointY - 1
            var x = Math.round(width * 0.4)
            while (y >= resultBottom.y && bottomDipArea[y * width + x] != 0) {
                rayToDipTopDistance++
                y--
            }
            if (bottomRayDipPointY < 0) resultBottom.rayY = 0
            else resultBottom.rayY = bottomRayDipPointY + midPointY
            if (bottomRayDipPointYBottom < 0) resultBottom.rayYBottom = 0
            else resultBottom.rayYBottom = bottomRayDipPointYBottom + midPointY
            resultBottom.yG += midPointY
            resultBottom.y += midPointY
            resultBottom.rayToDipTop = rayToDipTopDistance
            if (bottomRayDipPointY > 0) {
                var y = bottomRayDipPointY - 1
                var x = resultBottom.x
                while (x < width && bottomDipArea[x + y * width] != 0) x++
                resultBottom.dipTopEdgeDistance = x
            }
        } else resultBottom = { 'size': 0 };
        resultAll = {};
        if (resultTop.size != 0 && resultBottom.size == 0) {
            resultAll.x = resultTop.x
            resultAll.y = resultTop.y
            resultAll.height = resultTop.height
            resultAll.width = resultTop.width
            resultAll.size = resultTop.size
            resultAll.xG = resultTop.xG
            resultAll.yG = resultTop.yG
        }
        else if (resultTop.size == 0 && resultBottom.size != 0) {
            resultAll.x = resultBottom.x
            resultAll.y = resultBottom.y
            resultAll.height = resultBottom.height
            resultAll.width = resultBottom.width
            resultAll.size = resultBottom.size
            resultAll.xG = resultBottom.xG
            resultAll.yG = resultBottom.yG
        } else if (resultTop.size != 0 && resultBottom.size != 0) {
            resultAll.x = min(resultTop.x, resultBottom.x)
            resultAll.y = resultTop.y
            resultAll.height = resultBottom.y + resultBottom.height - resultTop.y
            resultAll.width = max(resultTop.width + resultTop.x, resultBottom.width + resultBottom.x) - resultAll.x
            resultAll.size = resultTop.size + resultBottom.size
            resultAll.xG = Math.round((resultTop.xG * resultTop.size + resultBottom.xG * resultBottom.size) / (resultAll.size))
            resultAll.yG = Math.round((resultTop.yG * resultTop.size + resultBottom.yG * resultBottom.size) / (resultAll.size))
        } else resultAll = { 'size': 0 };
    }
    return { 'leftDip': resultAll, 'leftTopDip': resultTop, 'leftBottomDip': resultBottom }
}
function rightConvex(areas, width) {
    var h = areas.length / width
    var measuredArea = 0
    var roofRE = roofRightEdge(areas, width)
    var rightBE = rightBottomEdge(areas, width)
    var straightArea = (rightBE.y - roofRE.y) * (width - 1 - (rightBE.x + roofRE.x) / 2)
    for (var y = roofRE.y; y < rightBE.y; y++) {
        var x = width - 1
        while (x >= 0 && areas[x + y * width] == 0) {
            measuredArea++;
            x--;
        }
    }
    return (straightArea - measuredArea)
}

function leftTopTilt(areas, width, n) {
    var h = areas.length / width
    var y1 = n.number.y + 1;
    var x1 = 0;
    while (x1 < width && areas[x1 + y1 * width] == 0) x1++
    var x2 = n.number.x;
    var y2 = h - 1;
    while (y2 >= 0 && areas[x2 + y2 * width] == 0) y2--

    var convex = (Math.abs(y1 - y2) + 1) * (x1 + x2) * 0.5 | 0;
    for (var y = y1; y <= y2; y++) {
        var x = 0
        while (x < width && areas[x + y * width] == 0) {
            x++;
            convex--
        }
    }


    return { 'dX': x1 - x2, 'dY': y2 - y1, 'convex': convex }
}
function rightBottomTilt(areas, width, n) {
    var h = areas.length / width
    var x1 = width - 1;
    var y1 = n.number.y + n.number.height - 2;
    x1 = width - 1
    while (x1 >= 0 && areas[x1 + y1 * width] == 0) x1--;
    var x2 = n.number.x + n.number.width - 2;
    var y2 = 0
    y2 = h - 1
    while (y2 >= 0 && areas[x2 + y2 * width] == 0) y2--

    var convex = (1 + Math.abs(y1 - y2)) * (width - 1 - (x1 + x2) * 0.5) | 0;
    for (var y = y2; y <= y1; y++) {
        var x = width - 1
        while (x >= 0 && areas[x + y * width] == 0) {
            x--;
            convex--
        }
    }

    return { 'dX': x2 - x1, 'dY': y1 - y2, 'convex': convex }
}

function leftDipRightSideDip(areas, width, n) {
    var result = { 'size': 0 };
    var l = areas.length
    var h = l / width
    var newArea = copyPage(areas, newArea);
    var minimi = leftTopEdge(areas, width)
    var maximi = leftBottomEdge(areas, width);
    if (minimi.y + 1 >= maximi.y) return result;
    var newArea2 = findHoles(areas, width);
    for (var i = 0; i < l; i++)newArea[i] += newArea2[i]
    var minX = min(minimi.x, maximi.x)
    var maxX = min(max(minimi.x, maximi.x) + 1, width)
    for (var y = max(0, minimi.y - 1); y < min(h - 1, maximi.y + 2); y++) {
        for (var x = minX; x < maxX; x++)newArea[x + y * width] = 2;
    }
    newArea = invertArea(newArea);
    newArea = findJoinedAreas(newArea, width)
    newArea = removeEdgeAreas(newArea, width)

    var rightSideDip = rightDip(newArea, width, n)
    if(rightSideDip.rightDip.size!=0)    return { 'size': rightSideDip.rightDip.size, 'height': rightSideDip.rightDip.height, 'width': rightSideDip.rightDip.width, 'y': rightSideDip.rightDip.y }
    else return {'size':0}
}
function leftRayDip(areas, width, n) {
    var result = { 'size': 0, 'topSize': 0, 'BottomSize': 0 };
    var h = areas.length / width
    var newArea = copyPage(areas, newArea);
    var minimi = leftTopEdge(areas, width)
    var maximi = leftBottomEdge(areas, width);
    if (minimi.y + 1 >= maximi.y) return result;
    var minX = max(minimi.x, maximi.x)
    var topRayDip = 0;
    var bottomRayDip = 0;
    var topMinX = width;
    var bottomMinX = width;
    var numberMiddle = ((n.y + (n.height / 2))) | 0
    for (var x = width - 1; x >= 0; x--) {
        for (var y = minimi.y; y < maximi.y; y++) {
            if ((y < numberMiddle) && newArea[x + y * width] != 0) topMinX = x;
            if ((y >= numberMiddle) && newArea[x + y * width] != 0) bottomMinX = x;
        }
    }
    for (var y = minimi.y; y < maximi.y; y++) {
        var x = min(topMinX, bottomMinX);
        while (x < width && newArea[x + y * width] == 0) {
            if (y < numberMiddle && x >= topMinX + 1) topRayDip++;
            if (y >= numberMiddle && x >= bottomMinX + 1) bottomRayDip++;
            x++;
        }
    }
    result = { 'size': (topRayDip + bottomRayDip), 'topSize': topRayDip, 'bottomSize': bottomRayDip };
    return result;
}
function rightRayDip(areas, width, n) {
    var result = { 'size': 0, 'topSize': 0, 'BottomSize': 0 };
    var h = areas.length / width
    var newArea = copyPage(areas, newArea);
    var minimi = rightTopEdge(areas, width)
    var maximi = rightBottomEdge(areas, width);
    if (minimi.y + 1 >= maximi.y) return result;
    var maxX = min(minimi.x, maximi.x)
    var topRayDip = 0;
    var bottomRayDip = 0;
    var topMaxX = 0;
    var bottomMaxX = 0;
    var numberMiddle = ((n.y + (n.height / 2))) | 0
    for (var x = 0; x < width; x++) {
        for (var y = minimi.y; y < maximi.y; y++) {
            if ((y < numberMiddle) && newArea[x + y * width] != 0) topMaxX = x;
            if ((y >= numberMiddle) && newArea[x + y * width] != 0) bottomMaxX = x;
        }
    }
    for (var y = minimi.y; y < maximi.y; y++) {
        var x = max(topMaxX, bottomMaxX);
        while (x >= 0 && newArea[x + y * width] == 0) {
            if (y < numberMiddle && x <= topMaxX - 1) {
                topRayDip++;
            }
            if (y >= numberMiddle && x <= bottomMaxX - 1) {
                bottomRayDip++;
            }
            x--;
        }
    }
    result.size = (topRayDip + bottomRayDip)
    result.topSize = topRayDip
    result.bottomSize = bottomRayDip
    return result;
}
function rightDip(areas, width, n) {
    var resultAll = { 'size': 0 }
    var resultTop = { 'size': 0 }
    var resultBottom = { 'size': 0 }
    var result = { 'rightDip': { 'size': 0 }, 'rightTopDip': { 'size': 0 }, 'rightBottomDip': { 'size': 0 } }
    var h = areas.length / width
    var newArea = copyPage(areas, newArea);
    var minimi = rightTopEdge(areas, width)
    var maximi = rightBottomEdge(areas, width);
    if (minimi.y + 1 >= maximi.y) return result;
    var newArea2 = findHoles(areas, width);
    for (var i = 0; i < areas.length; i++)newArea[i] += newArea2[i]
    var minX = min(minimi.x, maximi.x)
    var maxX = min(max(minimi.x, maximi.x) + 1, width)
    for (var y = max(0, minimi.y - 1); y < min(h - 1, maximi.y + 2); y++) {
        for (var x = minX; x < maxX; x++)newArea[x + y * width] = 2;
    }
    newArea = invertArea(newArea);
    newArea = findJoinedAreas(newArea, width)
    newArea = removeEdgeAreas(newArea, width)
    var dip = largestAreaNumber(newArea)
    var midPointY = (n.y + n.height * 0.5) | 0
    var midPoint = midPointY * width
    var l = newArea.length;
    for (var i = 0; i < l; i++) { if (newArea[i] != 0) newArea[i] = dip }
    var topDipArea = []
    for (var i = 0; i < midPoint; i++)topDipArea.push(newArea[i])
    var bottomDipArea = []
    for (var i = midPoint; i < l; i++)bottomDipArea.push(newArea[i])
    var topRayDipPointYTop = 0
    var topRayDipPointYBottom = 0
    var bottomRayDipPointY = -1
    if (dip != 0) {
        resultTop = areaData(topDipArea, dip, width)
        if (resultTop.size != 0) {
            var centerOfGravityPoint = centerOfGravity(topDipArea, dip, width)
            resultTop.xG = centerOfGravityPoint.xG
            resultTop.yG = centerOfGravityPoint.yG
            for (var y = resultTop.y + resultTop.height - 1; y >= resultTop.y; y--) {
                var x = width - 1;
                var topRayDipPointDepth = 0
                while (x >= 0 && areas[x + y * width] == 0) {
                    topRayDipPointDepth++
                    if (topRayDipPointDepth > 0.38 * width) {
                        topRayDipPointYTop = y
                        if (topRayDipPointYBottom == 0) topRayDipPointYBottom = y
                    }
                    x--;
                }
            }
            var rayToDipBottomDistance = 0
            var y = topRayDipPointYBottom + 1
            var x = Math.round(width * 0.6)
            while (y < resultTop.y + resultTop.height && topDipArea[y * width + x] != 0) {
                rayToDipBottomDistance++
                y++
            }
            resultTop.rayY = topRayDipPointYBottom
            resultTop.rayToDipBottom = rayToDipBottomDistance
            var rayToDipTopDistance = 0
            var y = topRayDipPointYTop - 1
            var x = Math.round(width * 0.6)
            while (y >= resultTop.y && topDipArea[y * width + x] != 0) {
                rayToDipTopDistance++
                y--
            }
            resultTop.rayYTop = topRayDipPointYTop
            resultTop.rayToDipTop = rayToDipTopDistance
            if (topRayDipPointYBottom != 0) {
                var y = topRayDipPointYBottom + 1
                var x = resultTop.x + resultTop.width - 1
                while (x > 0 && topDipArea[x + y * width] != 0) x--
                resultTop.dipBottomEdgeDistance = width - 1 - x
            }
        } else resultTop = { 'size': 0 };
        resultBottom = areaData(bottomDipArea, dip, width)
        if (resultBottom.size != 0) {
            var centerOfGravityPoint = centerOfGravity(bottomDipArea, dip, width)
            resultBottom.xG = centerOfGravityPoint.xG
            resultBottom.yG = centerOfGravityPoint.yG
            for (var y = resultBottom.y; y < resultBottom.y + resultBottom.height; y++) {
                var x = width - 1;
                var bottomRayDipPointDepth = 0
                while (x >= 0 && areas[x + (y + midPointY) * width] == 0 && bottomRayDipPointY == -1) {
                    x--;
                    bottomRayDipPointDepth++
                    if (bottomRayDipPointDepth > 0.4 * width) {
                        bottomRayDipPointY = y
                    }
                }
            }
            var rayToDipTopDistance = 0
            var y = bottomRayDipPointY - 1
            var x = Math.round(width * 0.6)
            while (y >= resultBottom.y && bottomDipArea[y * width + x] != 0) {
                rayToDipTopDistance++
                y--
            }
            if (bottomRayDipPointY < 0) resultBottom.rayY = 0
            else resultBottom.rayY = bottomRayDipPointY + midPointY
            resultBottom.yG += midPointY
            resultBottom.y += midPointY
            resultBottom.rayToDipTop = rayToDipTopDistance

        } else resultBottom = { 'size': 0 };
        resultAll = {};
        if (resultTop.size != 0 && resultBottom.size == 0) {
            resultAll.x = resultTop.x
            resultAll.y = resultTop.y
            resultAll.height = resultTop.height
            resultAll.width = resultTop.width
            resultAll.size = resultTop.size
            resultAll.xG = resultTop.xG
            resultAll.yG = resultTop.yG
        }
        else if (resultTop.size == 0 && resultBottom.size != 0) {
            resultAll.x = resultBottom.x
            resultAll.y = resultBottom.y
            resultAll.height = resultBottom.height
            resultAll.width = resultBottom.width
            resultAll.size = resultBottom.size
            resultAll.xG = resultBottom.xG
            resultAll.yG = resultBottom.yG
        } else if (resultTop.size != 0 && resultBottom.size != 0) {
            resultAll.x = min(resultTop.x, resultBottom.x)
            resultAll.y = resultTop.y
            resultAll.height = resultBottom.y + resultBottom.height - resultTop.y
            resultAll.width = max(resultTop.width + resultTop.x, resultBottom.width + resultBottom.x) - resultAll.x
            resultAll.size = resultTop.size + resultBottom.size
            resultAll.xG = Math.round((resultTop.xG * resultTop.size + resultBottom.xG * resultBottom.size) / (resultAll.size))
            resultAll.yG = Math.round((resultTop.yG * resultTop.size + resultBottom.yG * resultBottom.size) / (resultAll.size))
        } else resultAll = { 'size': 0 };
    }
    return { 'rightDip': resultAll, 'rightTopDip': resultTop, 'rightBottomDip': resultBottom }
}
function corners(areas, width) {
    var h = areas.length / width
    var result = {}
    result.roofLeft = {}
    result.roofRight = {}
    result.floorLeft = {}
    result.floorRight = {}
    result.roofLeft.distance = h * h + width * width
    result.roofRight.distance = h * h + width * width
    result.floorLeft.distance = h * h + width * width
    result.floorRight.distance = h * h + width * width
    result.roofLeft.x = 0
    result.roofLeft.y = 0
    result.roofRight.x = 0
    result.roofRight.y = 0
    result.floorLeft.x = 0
    result.floorLeft.y = 0
    result.floorRight.x = 0
    result.floorRight.y = 0
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            if (areas[x + y * width] != 0) {
                var dRL = x * x + y * y
                var dRR = (width - 1 - x) * (width - 1 - x) + y * y
                var dFL = x * x + (h - 1 - y) * (h - 1 - y)
                var dFR = (width - 1 - x) * (width - 1 - x) + (h - 1 - y) * (h - 1 - y)
                if (dRL < result.roofLeft.distance) {
                    result.roofLeft.distance = dRL
                    result.roofLeft.x = x
                    result.roofLeft.y = y
                }
                if (dRR < result.roofRight.distance) {
                    result.roofRight.distance = dRR
                    result.roofRight.x = x
                    result.roofRight.y = y
                }
                if (dFL < result.floorLeft.distance) {
                    result.floorLeft.distance = dFL
                    result.floorLeft.x = x
                    result.floorLeft.y = y
                }
                if (dFR < result.floorRight.distance) {
                    result.floorRight.distance = dFR
                    result.floorRight.x = x
                    result.floorRight.y = y
                }
            }
        }
    }
    result.roofLeft.distance = Math.round(Math.sqrt(result.roofLeft.distance))
    result.roofRight.distance = Math.round(Math.sqrt(result.roofRight.distance))
    result.floorLeft.distance = Math.round(Math.sqrt(result.floorLeft.distance))
    result.floorRight.distance = Math.round(Math.sqrt(result.floorRight.distance))
    return result
}
var validNumberMaxHeightToWidthRatio = 10
var validNumberMinHeightToWidthRatio = 0.6
var validNumberMinHeight = 12
var validNumberMinWidth = 4
function checkNumberValidity(numberData) {
    if (numberData.height > validNumberMaxHeightToWidthRatio * numberData.width) return false
    if (numberData.height < validNumberMinHeightToWidthRatio * numberData.width) return false
    if (numberData.height < validNumberMinHeight) return false;
    if (numberData.width < validNumberMinWidth) return false;
    return true;
}

function calculateIntensityProfile(anyPage, width) {
    var h = anyPage.length / width;
    var borderDivider = 8;
    var index = (width / borderDivider) | 0;
    var sectionWidth = ((borderDivider - 2) * width / borderDivider);
    var intensityProfile = [];
    var profileMin = m.min(anyPage);
    var profileMax = m.max(anyPage);
    for (var i = 0; i < intensityResolution + 1; i++)intensityProfile.push(0);
    for (var y = 0; y < h; y++) {
        for (var x = index; x < (index + sectionWidth); x++) {
            intensityProfile[(intensityResolution * ((anyPage[y * width + x] - profileMin) / (profileMax - profileMin))) | 0]++;
        }
    }
    return intensityProfile;
}

var intensityResolution = 80;

function horisontalBalancePage(page, width, numberColor, backGroundLimit) {
    var mask = calculateMask(page, width, numberColor, backGroundLimit).mask
    var nD = numberArea(mask, width)
    if (nD.width < 6) return page
    var lineMax = []
    var lineMin = []
    var l = page.length
    var h = l / width
    for (var x = 0; x < width; x++) {
        lineMax[x] = -10000
        lineMin[x] = 10000
        for (var y = 0; y < h; y++) {
            if (lineMax[x] < page[x + y * width]) lineMax[x] = page[x + y * width]
            if (lineMin[x] > page[x + y * width]) lineMin[x] = page[x + y * width]
        }
    }
    var sXX = 0
    var sZZ = 0
    var sX = 0
    var sZ = 0
    var sXZ = 0
    var n = 0
    for (var x = nD.x + 2; x < (nD.x + nD.width - 2); x++) {
        sXX += x * x
        sX += x
        n++
        if (numberColor == 'black') {
            sZ += lineMin[x]
            sZZ += lineMin[x] * lineMin[x]
            sXZ += lineMin[x] * x
        }
        else {
            sZ += lineMax[x]
            sZZ += lineMax[x] * lineMax[x]
            sXZ += lineMax[x] * x
        }
    }
    var denominator = (n * sXX - sX * sX)
    if (denominator == 0) return page
    var bB = (n * sXZ - sX * sZ) / denominator
    for (var x = 0; x < width; x++) {
        for (var y = 0; y < h; y++) {
            page[x + y * width] = page[x + y * width] - (x - width * 0.5) * bB
        }
    }
    page = scalePage(page)
    if (Math.abs(bB) < -100000) {
        mask = calculateMask(page, width, numberColor, backGroundLimit)
        var lineMax = []
        var lineMin = []
        var l = page.length
        var h = l / width
        for (var x = 0; x < width; x++) {
            lineMax[x] = -10000
            lineMin[x] = 10000
            for (var y = 0; y < h; y++) {
                if (lineMax[x] < page[x + y * width]) lineMax[x] = page[x + y * width]
                if (lineMin[x] > page[x + y * width]) lineMin[x] = page[x + y * width]
            }
        }
        var sXX = 0
        var sZZ = 0
        var sX = 0
        var sZ = 0
        var sXZ = 0
        var n = 0
        for (var x = nD.x + 2; x < (nD.x + nD.width - 2); x++) {
            sXX += x * x
            sX += x
            n++
            if (numberColor == 'black') {
                sZ += lineMin[x]
                sZZ += lineMin[x] * lineMin[x]
                sXZ += lineMin[x] * x
            }
            else {
                sZ += lineMax[x]
                sZZ += lineMax[x] * lineMax[x]
                sXZ += lineMax[x] * x
            }
        }
        var bB = (n * sXZ - sX * sZ) / (n * sXX - sX * sX)
        balanceCount--
    }
    return page
}
var balanceCount = 1
function verticalBalancePage(page, width, numberColor, backGroundLimit) {
    var mask = calculateMask(page, width, numberColor, backGroundLimit)
    var nD = numberArea(mask, width)
    if (nD.height < 6) return page
    var lineMax = []
    var lineMin = []
    var l = page.length
    var h = l / width
    for (var y = 0; y < h; y++) {
        lineMax[y] = -10000
        lineMin[y] = 10000
        for (var x = 0; x < width; x++) {
            if (lineMax[y] < page[x + y * width]) lineMax[y] = page[x + y * width]
            if (lineMin[y] > page[x + y * width]) lineMin[y] = page[x + y * width]
        }
    }
    var sYY = 0
    var sZZ = 0
    var sY = 0
    var sZ = 0
    var sYZ = 0
    var n = 0
    for (var y = nD.y + 2; y < (nD.y + nD.height - 2); y++) {
        sYY += y * y
        sY += y
        n++
        if (numberColor == 'black') {
            sZ += lineMin[y]
            sZZ += lineMin[y] * lineMin[y]
            sYZ += lineMin[y] * y
        }
        else {
            sZ += lineMax[y]
            sZZ += lineMax[y] * lineMax[y]
            sYZ += lineMax[y] * y
        }
    }
    var denominator = (n * sYY - sY * sY)
    if (denominator == 0) return page
    var bB = (n * sYZ - sY * sZ) / denominator
    for (var y = 0; y < h; y++) {
        for (var x = 0; x < width; x++) {
            page[x + y * width] = page[x + y * width] - y * bB
        }
    }
    page = scalePage(page)
    if (Math.abs(bB) < -100) {
        mask = calculateMask(page, width, numberColor, backGroundLimit)
        var lineMax = []
        var lineMin = []
        var l = page.length
        var h = l / width
        for (var y = 0; y < h; y++) {
            lineMax[y] = -10000
            lineMin[y] = 10000
            for (var x = 0; x < width; x++) {
                if (lineMax[y] < page[x + y * width]) lineMax[y] = page[x + y * width]
                if (lineMin[y] > page[x + y * width]) lineMin[y] = page[x + y * width]
            }
        }
        var sYY = 0
        var sZZ = 0
        var sY = 0
        var sZ = 0
        var sYZ = 0
        var n = 0
        for (var y = nD.y + 2; y < (nD.y + nD.height - 2); y++) {
            sYY += y * y
            sY += y
            n++
            if (numberColor == 'black') {
                sZ += lineMin[y]
                sZZ += lineMin[y] * lineMin[y]
                sYZ += lineMin[y] * y
            }
            else {
                sZ += lineMax[y]
                sZZ += lineMax[y] * lineMax[y]
                sYZ += lineMax[y] * y
            }
        }
        var bB = (n * sYZ - sY * sZ) / (n * sYY - sY * sY)

    }

    return page
}
function calculateBackGroundArea(profile, numberColor, backGroundLimit) {
    var sum = backGroundLimit * m.sum(profile);
    if (numberColor == 'black') sum = (1 - backGroundLimit) * m.sum(profile);
    var count = 0;
    for (var i = 0; i < intensityResolution; i++) {
        count += profile[i];
        if (count > sum) return 100 * i / intensityResolution;
    }
    return 0;
}
function calculateMaskTest(page, width, numberColor, backGroundLimit) {
    var l = page.length
    var mask = horisontalChanges(page, width, numberColor);
    return cleanUpMask(mask, width);
}
function calculateMask(page, width, numberColor, backGroundLimit) {
    var profile = calculateIntensityProfile(page, width);
    var mask = [];
    var l = page.length;
    var limit = calculateBackGroundArea(profile, numberColor, backGroundLimit);
    var numberCode = 2;
    if (numberColor == 'black') numberCode = 0;
    var backGroundCode = (2 - numberCode);
    for (var i = 0; i < l; i++) {
        if (page[i] < limit) mask.push(backGroundCode);

        else {
            mask.push(numberCode);
        }
    }
    return cleanUpMask(mask, width);
}
function cropPicture(pixels, coordinates) {
    if (!pixels.width) pixels.width = pixels.shape[0];
    if (!pixels.height) pixels.height = pixels.shape[1];
    var pictureWidth = pixels.width
    var rawPicture = {}
    rawPicture.data = []
    rawPicture.width = coordinates[2] - coordinates[0] + 1
    rawPicture.height = coordinates[3] - coordinates[1] + 1;
    for (var y = coordinates[1]; y <= coordinates[3]; y++) {
        for (var x = coordinates[0]; x <= coordinates[2]; x++) {
            for (var i = 0; i < 4; i++)rawPicture.data.push(pixels.data[4 * (x + y * pictureWidth) + i])
        }
    }
    return rawPicture;
}
function copyPictureToPage(rawPicture, anyPage) {
    anyPage = [];
    var eHeight = rawPicture.height;
    var w = rawPicture.width;
    for (var y = 0; y < eHeight; y++) {
        for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            var value = (rawPicture.data[i] * rawPicture.data[i] +
                rawPicture.data[i + 1] * rawPicture.data[i + 1] +
                rawPicture.data[i + 2] * rawPicture.data[i + 2]);
            anyPage[x + y * w] = value;
        }
    }
    anyPage = integrate3(anyPage, w);
    return anyPage;
}
function numberDimensions(picture, coord, numberColor, backGroundLimit) {
    var defaultResult = { 'numberHeight': 0, 'numberWidth': 0, 'numberSeparatorHeight': 0 }
    if (!coord || coord.length == 0) return defaultResult
    var newCoord = []
    for (var i = 0; i < 4; i++)newCoord[i] = coord[i]
    if (coord[0] > coord[2]) {
        newCoord[0] = coord[2]
        newCoord[2] = coord[0]
    }
    if (coord[1] > coord[3]) {
        newCoord[1] = coord[3]
        newCoord[3] = coord[1]
    }
    var croppedPicture = cropPicture(picture, newCoord)
    var page = copyPictureToPage(croppedPicture, page)
    var width = newCoord[2] - newCoord[0] + 1
    var numberMask = calculateMask(page, width, numberColor, backGroundLimit)
    var numberMask = cleanTopCorners(numberMask, width)
    var number = numberArea(numberMask, width);
    var numberSeparatorH = numberSeparatorHeight(numberMask, width)
    if (number.y != 0) {
        if (numberSeparatorH > 2) {
            return { 'numberHeight': number.height, 'numberWidth': number.width, 'numberSeparatorHeight': numberSeparatorH }
        }
    }
    return defaultResult
}
var dFlag = 0
function debugFlag(status) {
    dFlag = status;
    return dFlag;
}
function debug(text, text2, text3, text4) {
    if (dFlag != 0) {
        if (text2) {
            if (text3) {
                if (text4) console.log(text, text2, text3, text4)
                else console.log(text, text2, text3)

            } else console.log(text, text2)

        } else console.log(text)

    }
}
function readDebugFlag() { return dFlag }
function pageToConsole(page, width, n, length, extend) {
    if (dFlag == 0) return;
    if (extend && dFlag != extend) return;
    if (dFlag > 1) dFlag--
    var h = page.length / width
    for (var y = 0; y < h; y++) {
        var line = '' + addLeadingZeros(y, 1)
        for (var x = 0; x < width; x++) {
            var value = '1'
            if (length) value = addLeadingZeros(page[x + y * width], length - 1)
            if (n) {
                if (n.leftTopEdge.y == y && n.leftTopEdge.x == x) value = 'A'
                if (n.rightTopEdge.y == y && n.rightTopEdge.x == x) value = 'F'
                if (n.leftBottomEdge.y == y && n.leftBottomEdge.x == x) value = 'B'
                if (n.rightBottomEdge.y == y && n.rightBottomEdge.x == x) value = 'E'
                if (n.roofLeftEdge) {
                    if (n.roofLeftEdge.y == y && n.roofLeftEdge.x == x) value = 'H'
                    if (n.roofRightEdge.y == y && n.roofRightEdge.x == x) value = 'G'
                    if (n.floorLeftEdge.y == y && n.floorLeftEdge.x == x) value = 'C'
                    if (n.floorRightEdge.y == y && n.floorRightEdge.x == x) value = 'D'
                }
            }
            if (page[x + y * width] != 0) line += ' ' + value;
            else {
                if (!length) line += ' -'
                if (length == 2) line += ' --'
                if (length == 3) line += ' ---'
            }
        }
        console.log(line);
    }
    console.log(' ')
}
var start = []
var times = []
var totalTime = 0
function startTime() {
    if (dFlag == 0) return 0;
    start = process.hrtime()
    times = []
    totalTime = 0
}
function getTime() {
    if (dFlag == 0) return 0;
    return process.hrtime(start)[1] / 1e6
}
function addTime(i) {
    if (dFlag == 0) return 0;
    times[i] = (getTime())
}
function closeTimes() {
    if (dFlag == 0) return 0;
    totalTime = times[times.length - 1]
    for (var i = 0; i < times.length; i++)times[i] = times[i] / totalTime
}
function timesText() {
    if (dFlag == 0) return '';
    var text = ''
    for (var i = 0; i < times.length; i++)text += i + ',' + (100 * times[i]).toFixed(0) + '% ,'
    return text + 'TOTAL=' + totalTimeText()
}
function totalTimeText() {
    if (dFlag == 0) return 0;

    return ' ' + totalTime.toFixed(2) + ' seconds '
}
function showTimesText() {
    if (dFlag == 0) return 0;
    console.log(timesText())
}
function createNumberData(page, originalWidth, conf, natural) {

    //        startTime()
    pageToConsole(page, originalWidth, undefined, undefined, 2)
    var numberData = {}
    numberData.digit = 'undefined'
    numberData.digitReliability = 'undefined'
    numberData.pageWidth = originalWidth;
    numberData.pageHeight = page.length / originalWidth;
    var fullAreas = []
    // addTime(0)
    fullAreas = extractLargestJoinedArea(page, originalWidth)
    // addTime(1)
    if (!natural) fullAreas = sputterAreas(fullAreas, originalWidth)
    // addTime(2)
    fullAreas = cleanTopCorners(fullAreas, originalWidth)
    // addTime(3)
    var nArea = numberArea(fullAreas, originalWidth)
    if (checkNumberValidity(nArea) == false) {
        debug('not a valid number')
        return { 'number': { 'x': 0, 'y': 0, 'width': 0, 'height': 0 } }
    }
    nArea.x += 0
    nArea.y += 1
    nArea.width -= 0
    nArea.height -= 1
    if (nArea.width <= 0) nArea.width = 1
    if (nArea.height <= 0) nArea.height = 1
    var oX = nArea.x
    var oY = nArea.y

    var width = nArea.width
    var areas = cropPage(fullAreas, originalWidth, nArea).page
    var nArea = numberArea(areas, width)
    numberData.number = nArea;
    //    numberData.number = nArea
    // addTime(4)
    var radar = radarEdges(areas, width)
    // addTime(5)
    numberData.number.xG = radar.xG
    numberData.number.yG = radar.yG
    numberData.number.topBottomRatio = radar.topBottomRatio
    numberData.number.ovality = radar.ovality
    numberData.number.corners = radar.corners
    // addTime(6)
    numberData.rightConvex = rightConvex(areas, width)
    // addTime(7)
    numberData.roofTopConvex = roofTopConvex(areas, width)
    // addTime(8)
    var rightDippi = rightDip(areas, width, nArea)
    numberData.rightDip = rightDippi.rightDip
    numberData.rightTopDip = rightDippi.rightTopDip;
    // addTime(9)
    numberData.rightBottomDip = rightDippi.rightBottomDip;
    numberData.roofRadar = roofRadar(areas, width, numberData)
    numberData.floorRadar = floorRadar(areas, width, numberData)
    numberData.leftRadar = leftRadar(areas, width, numberData)
    // addTime(10)
    numberData.leftTopEdge = leftTopEdge(areas, width)
    numberData.rightTopEdge = rightTopEdge(areas, width)
    numberData.rightBottomEdge = rightBottomEdge(areas, width)
    numberData.leftBottomEdge = leftBottomEdge(areas, width)
    numberData.roofLeftEdge = roofLeftEdge(areas, width)
    // addTime(11)
    numberData.floorLeftEdge = floorLeftEdge(areas, width)
    numberData.roofRightEdge = roofRightEdge(areas, width)
    numberData.floorRightEdge = floorRightEdge(areas, width)
    numberData.holes = holes(areas, width)
    // addTime(12)
    pageToConsole(areas, width, numberData)
    //    nArea = numberArea(areas, width)
    //    numberData.number = nArea;
    //    var radar = radarEdges(areas, width)
    //    numberData.number.xG = radar.xG
    //    numberData.number.yG = radar.yG
    //    numberData.number.topBottomRatio = radar.topBottomRatio
    //    numberData.number.ovality = radar.ovality
    var leftDippi = leftDip(areas, width, nArea);
    numberData.leftDip = leftDippi.leftDip;
    numberData.leftTopDip = leftDippi.leftTopDip;
    numberData.leftBottomDip = leftDippi.leftBottomDip;
    var leftRayDippi = leftRayDip(areas, width, nArea);
    numberData.leftRayDip = leftRayDippi.size;
    // addTime(13)
    numberData.leftTopRayDip = leftRayDippi.topSize;
    numberData.leftBottomRayDip = leftRayDippi.bottomSize;
    var rightRayDippi = rightRayDip(areas, width, nArea);
    // addTime(14)
    numberData.rightRayDip = rightRayDippi.size;
    numberData.rightTopRayDip = rightRayDippi.topSize;
    numberData.rightBottomRayDip = rightRayDippi.bottomSize;
    numberData.leftDipRightSideDip = leftDipRightSideDip(areas, width, nArea)
    // addTime(15)
    var roofAndFloorDipResult = roofAndFloorDip(areas, width)
    numberData.floorDip = roofAndFloorDipResult.floorDip
    numberData.roofDip = roofAndFloorDipResult.roofDip
    // addTime(16)
    // addTime(17)
    numberData.topBarBottomCurve = topBarBottomCurve(areas, width, numberData)
    // addTime(18)
    numberData.holeDips = holeDips(areas, width, numberData)
    // addTime(19)
    numberData.diagonalBarCurve = diagonalBarCurve(areas, width, numberData)
    // addTime(20)
    numberData.rightTopDipDiagonalCurve = rightTopDipDiagonalCurve(areas, width, numberData)
    numberData.rightTopDipDiagonalCurveFor4 = rightTopDipDiagonalCurveFor4(areas, width, numberData)
    numberData.roofLeftCurve = roofLeftConcave(areas, width, numberData)
    numberData.roofLeftConvex = roofLeftConvex(areas, width, numberData)
    numberData.floorLeftCurve = floorLeftCurve(areas, width, numberData)
    numberData.floorLeftCurveFor4 = floorLeftCurveFor4(areas, width, numberData)
    // addTime(21)
    numberData.leftTopTilt = leftTopTilt(areas, width, numberData)
    numberData.rightBottomTilt = rightBottomTilt(areas, width, numberData)
    numberData.corners = corners(areas, width)
    numberData.number.oX = oX
    numberData.number.oY = oY
    // addTime(22)
    //   closeTimes()
    //   showTimesText()
    //   debugFlag(0)
    debug(numberData)
    return numberData
}

function createMeterData(page, width) {
    var meterData = features(page, width)
    console.log(meterData)
    return meterData;

}
module.exports = {
    closeTimes: function () { return closeTimes() },
    showTimesText: function () { return showTimesText() },
    startTime: function () { return startTime() },
    findJoinedAreas: function (m, width) { return findJoinedAreas(m, width) },
    largestAreaNumber: function (a) { return largestAreaNumber(a) },
    areaData: function (a, number, width) { return areaData(a, number, width) },
    changeArea: function (a, oldArea, newArea) { return changeArea(a, oldArea, newArea) },
    changeAllAreas: function (a, newArea) { return changeAllAreas(a, newArea) },
    findHoles: function (areas, width) { return findHoles(areas, width) },
    extractArea: function (areas, areaNumber) { return extractArea(areas, areaNumber) },
    joinPages: function (page1, page2, page3) { return joinPages(page1, page2) },
    copyPage: function (page1, page2) { return copyPage(page1, page2) },
    scalePage: function (page) { return scalePage(page) },
    addLeadingZeros: function (page, number) { return addLeadingZeros(page, number) },
    addLeadingSpaces: function (text, number) { return addLeadingSpaces(text, number) },
    cleanUpMask: function (mask, width) { return cleanUpMask(mask, width) },
    createNumberData: function (page, width, conf, natural) { return createNumberData(page, width, conf, natural) },
    createMeterData: function (page, width) { return createMeterData(page, width) },
    pageToConsole: function (page, width,n,length) { return pageToConsole(page, width,n,length) },
    extractLargestJoinedArea: function (page, width) { return extractLargestJoinedArea(page, width) },
    numberArea: function (page, width) { return numberArea(page, width) },
    numberSeparatorHeight: function (page, width) { return numberSeparatorHeight(page, width) },
    integrate3: function (page, width) { return integrate3(page, width) },
    debug: function (text) { return debug(text) },
    cropPage: function (page, width, cut) { return cropPage(page, width, cut) },
    debugFlag: function (status) { return debugFlag(status) },
    readDebugFlag: function () { return readDebugFlag() },
    horisontalChanges: function (page, width, numberColor) { return horisontalChanges(page, width, numberColor) },
    calculateMask: function (page, width, numberColor, backGroundLimit) { return calculateMask(page, width, numberColor, backGroundLimit) },
    numberDimensions: function (picture, coord, numberColor, backGroundLimit) { return numberDimensions(picture, coord, numberColor, backGroundLimit) },
    verticalBalancePage: function (page, width, numberColor, backGroundLimit) { return verticalBalancePage(page, width, numberColor, backGroundLimit) },
    horisontalBalancePage: function (page, width, numberColor, backGroundLimit) { return horisontalBalancePage(page, width, numberColor, backGroundLimit) }
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/numberMethods.js
// module id = 442
// module chunks = 0